import { auction } from './auction';
import { balance } from './balance';
import { betPosition } from './betPosition';
import { calltracking } from './calltracking';
import { checkoutInfo } from './checkoutInfo';
import { config } from './config';
import { depositAccount } from './depositAccount';
import { draft } from './draft';
import { dynamicPricingAttributes } from './dynamicPricing';
import { elementsVisibility } from './elementsVisibility';
import { experiments } from './experiments';
import { fairPlay } from './fairPlay';
import { layout } from './layout';
import { offer } from './offer';
import { publishAvailable } from './publishAvailable';
import { publishInfo } from './publishInfo';
import { publishTerms } from './publishTerms';
import { recommendedPackages } from './recommendedPackages';
import { termsDurations } from './termsDurations';
import { topBets } from './topBets';
import { user } from './user';
import { paidPublication, publicationPackages, recommendedPackages as recommendedPackagesV2 } from './v2';

export const ServicePickerWidgetReducers = {
  auction,
  balance,
  betPosition,
  calltracking,
  checkoutInfo,
  config,
  depositAccount,
  draft,
  dynamicPricingAttributes,
  elementsVisibility,
  experiments,
  fairPlay,
  layout,
  offer,
  publishAvailable,
  publishInfo,
  publishTerms,
  recommendedPackages,
  termsDurations,
  topBets,
  user,
};

export const ServicePickerWidgetReducersV2 = {
  paidPublication,
  recommendedPackages: recommendedPackagesV2,
  publicationPackages,
};
